import { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import DeleteEvaluationModal from '../screens/evaluations/partials/DeleteEvaluationModal';
import ErrorEvaluationModal from '../screens/evaluations/partials/ErrorEvaluationModal';
import FinalizeEvaluationModal from '../screens/evaluations/partials/FinalizeEvaluationModal';
import DeleteFavoritesModal from '../screens/favorites/partials/DeleteFavoritesModal';
import FavoritesModal from '../screens/favorites/partials/FavoritesModal';
import FooterBar from './partials/FooterBar';

import TopBar from './partials/TopBar';


const ScrollToTopEffect = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

const PrivateLayout = ({ children, activeTree, customTree }) => (
	<>
		<ScrollToTopEffect />
		<div className="relative top-12 lg:top-24 print:top-0 bg-oly-gray-lightestAlpha45 print:bg-white">
			<TopBar activeTree={activeTree} customTree={customTree} />
			<div className="relative mx-auto max-w-[1920px] print:max-w-none lg:pb-14">
				<div className="flex flex-col h-full lg:flex-row">
					{children}
				</div>
			</div>
			<FooterBar />
		</div>
		<FavoritesModal />
		<DeleteFavoritesModal />
		<DeleteEvaluationModal />
		<FinalizeEvaluationModal />
		<ErrorEvaluationModal />
	</>
);
export default memo(PrivateLayout);
